<mat-card class="layout-panel">
  <div class="panel">
    <div class="panel-body">
      <rfc-read-more
        [text]="description | i18n"
        [maxLength]="isMobile ? 100 : undefined"
      ></rfc-read-more>
    </div>
  </div>
</mat-card>
